import { API, API_GET_ID } from '../../Config'

export const GetSingleUser = (id) => {
  return (
    API_GET_ID(API.user,id)
  )
}

